<template>
  <div v-if="data">
    <v-tabs v-model="activo" centered slider-color="red darken-4">
      <v-tab :href="`#tarifario`">
        Habitaciones
      </v-tab>
      <v-tab :href="`#descripcion`">
        Descripción
      </v-tab>
      <v-tab :href="`#promos`" v-if="data.promociones.promocion || data.adicionales.adicional">
        Promociones / Adicionales
      </v-tab>
      <v-tab :href="`#traslados`" v-if="trasladosRs.length > 0">
        Traslados
      </v-tab>
      <v-tab :href="`#excursiones`" v-if="excursiones.length > 0">
        Excursiones
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="activo">
      <v-tab-item :value="`tarifario`">
        <v-card flat>
          <v-card-text>
            <v-chip label color="light-blue lighten-5" text-color="light-blue darken-4" small>
              <v-icon left>info</v-icon>
              {{ mensajeIva }}
            </v-chip>
            <PanelTarifario :data="h" v-for="(h, hindx) in agruparHabitaciones(tarifarios)" :key="`ptar-${hindx}`">
            </PanelTarifario>
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item :value="`descripcion`">
        <v-card flat>
          <v-card-text>
            <pre>
                            {{ data.notas }}
                        </pre
            >
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item :value="`promos`">
        <v-card flat>
          <v-card-text>
            <v-container class="py-0">
              <v-layout row wrap justify-center>
                <v-flex xs12 md6 v-if="data.promociones.promocion">
                  <v-list dense>
                    <template v-for="(item, index) in toArray(data.promociones.promocion)">
                      <v-subheader v-if="index === 0" :key="item.header">
                        Promociones
                      </v-subheader>

                      <v-divider class="my-0"></v-divider>

                      <v-list-tile avatar :key="index">
                        <v-list-tile-content>
                          <v-list-tile-title v-html="item" class="caption"></v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                    </template>
                  </v-list>
                </v-flex>
                <v-flex xs12 md6 v-if="data.adicionales.adicional">
                  <v-list dense>
                    <template v-for="(item, index) in toArray(data.adicionales.adicional)">
                      <v-subheader v-if="index === 0" :key="item.header">
                        Adicionales
                      </v-subheader>
                      <v-divider class="my-0"></v-divider>
                      <v-list-tile avatar :key="index">
                        <v-list-tile-content>
                          <v-list-tile-title v-html="item" class="caption"></v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                    </template>
                  </v-list>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item :value="`traslados`" class="contraslados">
        <div ref="rTraslado"></div>
      </v-tab-item>
      <v-tab-item :value="`excursiones`" class="conexcursiones">
        <div ref="rExcursion"></div>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import PanelTarifario from "@/components/tarifario/PanelTarifario.vue"
import PanelTrasladoTable from "@/components/traslados/PanelTrasladoTable.vue"
import Vue from "vue"
export default {
  name: "panelDescripcionTarifario",
  props: ["idTarifa", "tarifarios"],
  components: {
    PanelTarifario,
    PanelTrasladoTable
  },
  mounted() {
    this.prepararInstancia()
    this.getDescripcion()
  },
  created() {},
  methods: {
    ...mapGetters("filtroHoteles", {
      getDescripciones: "getDescripciones"
    }),
    getDescripcion() {
      this.data = this.getDescripciones().find(d => d.idTarifa === this.idTarifa)
    },
    agruparHabitaciones(tarifarios) {
      let _this = this
      const habitacion = [...new Set(tarifarios.map(data => data.id))].map(u => {
        const filtrados = tarifarios.filter(d => d.id === u)
        const tarifario = filtrados.map(f => f.tarifario)
        return { id: u, nombre: filtrados[0].nombre, filtrados: tarifario }
      })
      return habitacion
    },
    prepararInstancia() {
      let IntanciaClass = Vue.extend(PanelTrasladoTable)
      this.instance = new IntanciaClass({
        propsData: {
          data: this.trasladosRs,
          isTraslado: true
        }
      })
      this.instance.$mount()
      // INstancia excursiones
      let IntanciaExc = Vue.extend(PanelTrasladoTable)
      this.instanceExcursiones = new IntanciaExc({
        propsData: {
          data: this.excursiones,
          isTraslado: false
        }
      })
      this.instanceExcursiones.$mount()
    }
  },
  data() {
    return {
      activo: "tarifario",
      data: null,
      instance: null,
      instanceExcursiones: null
    }
  },
  computed: {
    ...mapGetters("filtroHoteles", {
      rq: "getRq"
    }),
    mensajeIva() {
      if (this.rq.isNacional) {
        return "Tarifas por habitación por noche IVA incluido. Exclusivas para pasajeros Argentinos. Sujetas a modificación sin previo aviso."
      }

      return "Tarifas por habitación por noche sin incluir IVA, sujetas a modificación sin previo aviso."
    },
    ...mapGetters("adicionales", {
      trasladosRs: "getTrasladosRS",
      getHandler: "handler",
      excursiones: "getExcursiones"
    })
  },
  watch: {
    activo(newVal) {
      if (newVal === "traslados") {
        this.$refs.rTraslado.appendChild(this.instance.$el)
      }
      if (newVal === "excursiones") {
        this.$refs.rExcursion.appendChild(this.instanceExcursiones.$el)
      }
    }
  }
}
</script>
<style scoped>
pre {
  overflow-x: auto;
  white-space: pre-wrap;
  white-space: -moz-pre-wrap;
  white-space: -pre-wrap;
  white-space: -o-pre-wrap;
  word-wrap: break-word;
}
</style>
